var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33049 0.609619H14.6695C18.0705 0.609619 19.9905 2.51533 20.0005 5.87526V15.1025C20.0005 18.4614 18.0705 20.3681 14.6695 20.3681H5.33049C1.92949 20.3681 0.000488281 18.4614 0.000488281 15.1025V5.87526C0.000488281 2.51533 1.92949 0.609619 5.33049 0.609619ZM10.0495 16.2781C10.4805 16.2781 10.8395 15.962 10.8795 15.5372V5.47021C10.9195 5.16395 10.7705 4.85671 10.5005 4.68975C10.2195 4.5218 9.87949 4.5218 9.61049 4.68975C9.33949 4.85671 9.19049 5.16395 9.21949 5.47021V15.5372C9.27049 15.962 9.62949 16.2781 10.0495 16.2781ZM14.6505 16.2781C15.0705 16.2781 15.4295 15.962 15.4805 15.5372V12.2968C15.5095 11.9796 15.3605 11.6843 15.0895 11.5163C14.8205 11.3484 14.4805 11.3484 14.2005 11.5163C13.9295 11.6843 13.7805 11.9796 13.8205 12.2968V15.5372C13.8605 15.962 14.2195 16.2781 14.6505 16.2781ZM6.21949 15.5372C6.17949 15.962 5.82049 16.2781 5.38949 16.2781C4.95949 16.2781 4.59949 15.962 4.56049 15.5372V8.71061C4.53049 8.40336 4.67949 8.09809 4.95049 7.93014C5.21949 7.7622 5.56049 7.7622 5.83049 7.93014C6.09949 8.09809 6.25049 8.40336 6.21949 8.71061V15.5372Z",
    fill: "#1A374E",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeIcon);
export default __webpack_public_path__ + "static/media/trade_icon.6068dc6235179b2bd8e37bcb107f6e9b.svg";
export { ForwardRef as ReactComponent };